export class AssetFilterModel {
    constructor(
        public name: string = '',
        public publisherIds: Array<number>) {
    }
}


// WEBPACK FOOTER //
// ./src/app/assets/asset-filter.model.ts